import PropTypes from "prop-types";
import { useRef, useState } from "react";
import badge from "../../assets/images/Product/product-badge.png";
import { handleGlobalInputChange } from "../../helpers/functions";
import Cookies from "js-cookie";
import { usePostApiRequest } from "../../helpers/api";
import InlineSpinner from "../loading/InlineSpinner";
import AddCustomizeModal from "./AddCustomizeModal";
import { useQueryClient } from "@tanstack/react-query";
import { usePartner } from "../../helpers/BrandPageAPI";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const customerId = customerData?.Id ? customerData.Id : null;
const customerCode = customerData?.Code ? customerData.Code : null;

const clarityOptions = [
  { id: "YW", name: "Yellow Gold" },
  { id: "W", name: "White Gold" },
  { id: "PW", name: "Rose" },
];
const caratOptions = [
  { id: "10K", name: "10KT" },
  { id: "14K", name: "14KT" },
  { id: "18K", name: "18KT" },
];

const ProductDescriptionInfo = ({
  product,
  shortDescription,
  showBottomContent,
  sizeData,
}) => {
  const { partnerData } = usePartner();
  const StoneName = partnerData?.StoneName;
  const buttonColor = partnerData?.StoreColor;
  const email = partnerData.Email;
  const mobileNo = partnerData.Mobile;
  const [quantityCount, setQuantityCount] = useState(1);
  const [displayedGrossWt, setDisplayedGrossWt] = useState(
    product.NetWt * 0.875
  );
  const [customizeModalShow, setCustomizeModalShow] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Clarity: "YW",
    Carat: "14K",
    Size: product.ItemSize || "",
  });
  const textareaRef = useRef(null);
  const postApiRequest = usePostApiRequest();
  const queryClient = useQueryClient();

  const calculateGrossWt = (caratValue) => {
    const baseWeight = product.NetWt;

    switch (caratValue) {
      case "10K":
        return baseWeight * 0.76;
      case "14K":
        return baseWeight * 0.875;
      case "18K":
        return baseWeight;
      default:
        return baseWeight * 0.875;
    }
  };
  const handleInputChange = (e) => {
    handleGlobalInputChange(e, setFormData);

    if (e.target.name === "Carat") {
      setDisplayedGrossWt(calculateGrossWt(e.target.value));
    }
  };

  const handleAddToCart = async (e, product) => {
    e.preventDefault();
    const instructions = textareaRef.current
      ? textareaRef.current.value.trim()
      : "";

    setLoading(true);
    const data = {
      CustomerId: customerId,
      CustomerCode: customerCode,
      Quantity: quantityCount,
      CategoryId: product.GrpNo,
      ProductId: product.StyleId,
      StyleCode: product.StyleCode,
      Weight: displayedGrossWt,
      DiamondWt: product.ClientDiamondWt,
      Carat: formData.Carat,
      Color: formData.Clarity,
      CustomizeText: instructions,
      Size: formData.Size,
    };

    try {
      const response = await postApiRequest({
        url: "/Partner/AddCart",
        method: "POST",
        data: data,
        onSuccess: setCustomizeModalShow(false),
      });
      if (response.Status === true) {
        queryClient.invalidateQueries({
          queryKey: ["cartItemCount"],
          exact: false,
        });
        queryClient.invalidateQueries({
          queryKey: ["cartData"],
          exact: false,
        });
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setQuantityCount(1);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`product-details-content ml-70 ${showBottomContent ? "quickview" : "default-view"
          }`}
      >
        <h2>{product.StyleCode}</h2>
        <p className="collection">{product.GrpName}</p>
        <b>SKU: {product.StyleCode}</b>
        <div className={"pro-details-list"}>
          {shortDescription === "true" && (
            <p className="quickview">{product.Description}</p>
          )}
        </div>

        {/* New Customization Section */}
        <div className={`product-size-clientDiamond-carat`}>
          <select
            value={formData.Carat}
            onChange={handleInputChange}
            name="Carat"
            id={"product_Carat_" + product.StyleId}
            className="select_option"
          >
            {caratOptions.map((option) => (
              <option value={option.id} key={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <select
            value={formData.Clarity}
            onChange={handleInputChange}
            name="Clarity"
            id={"product_Clarity_" + product.StyleId}
            className="select_option"
          >
            {clarityOptions.map((option) => (
              <option value={option.id} key={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          {![7, 9, 10, 12, 67, 72, 74, 79].includes(product.GrpNo) && (
            <select
              value={formData.Size}
              onChange={handleInputChange}
              name="Size"
              id={"product_Size_" + product.StyleId}
              className="select_option"
            >
              {sizeData?.map((option, index) => (
                <option value={option.CommonMasterName} key={index}>
                  {option.CommonMasterName}
                </option>
              ))}
            </select>
          )}
        </div>

        <div className={`certified_assurance_logo`}>
          <img src={badge} alt="" className="logo1" />
          <div className="quality_assurance">
            <h4>{StoneName} Quality Assurance</h4>
            <p className="assurance_disc">
              Because The Most Beautiful Deserves Flawless Quality, each piece
              undergoes rigorous quality checks to ensure it meets our quality
              standards.
            </p>
          </div>
        </div>

        <div className={`pro-details-quality`}>
          QTY :
          <div className="cart-plus-minus">
            <button
              onClick={() =>
                setQuantityCount(quantityCount > 1 ? quantityCount - 1 : 1)
              }
              className="dec qtybutton"
            >
              -
            </button>
            <input
              className="cart-plus-minus-box"
              type="text"
              value={quantityCount}
              readOnly
            />
            <button
              onClick={() => setQuantityCount(quantityCount + 1)}
              className="inc qtybutton"
            >
              +
            </button>
          </div>
        </div>

        <div className="product_weight">
          <span>{displayedGrossWt.toFixed(2) || 0} GM</span>
          <span> | </span>
          <span>{product.ClientDiamondWt || 0} CT</span>
        </div>

        <div className="pro_btn_con">
          {/* {customerId && ( */}
          <>
            <button
              className="button primary_btn"
              onClick={(e) => handleAddToCart(e, product)}
              style={{ background: buttonColor }}
            >
              {isLoading ? <InlineSpinner /> : "Add to cart"}
            </button>
            <button
              className={`button underline_btn`}
              title="Add Customization"
              onClick={() => setCustomizeModalShow(true)}
            >
              + Add Customization
            </button>
          </>
          {/* )} */}
        </div>

        <div className="product_delivery_query_contact_details">
          <h4>ESTIMATED DELIVERY: 15 DAYS</h4>
          {showBottomContent && (
            <div className="query">
              <p>
                <b>IN CASE OF QUERY </b>
                <br />
                {/* Write to us @ info@kalistajewels.com or WhatsApp us @ +91 99999
                99999 */}
                Write to us @ {email} or WhatsApp us @ {mobileNo}
              </p>
            </div>
          )}
        </div>
      </div>
      {customizeModalShow && (
        <AddCustomizeModal
          show={customizeModalShow}
          onHide={() => setCustomizeModalShow(false)}
          product={product}
          handleAddToCart={handleAddToCart}
          textareaRef={textareaRef}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

ProductDescriptionInfo.propTypes = {
  product: PropTypes.shape({}).isRequired,
  shortDescription: PropTypes.string,
  showBottomContent: PropTypes.bool,
};

export default ProductDescriptionInfo;
